module.exports = __webpack_public_path__ + "img/logo-soluções-color.374bc3b2.png";